package com.downdogapp.client.controllers.start

import com.downdogapp.client.MANIFEST
import com.downdogapp.client.Strings
import com.downdogapp.client.api.HistoryItem
import com.downdogapp.client.controllers.HistoryItemViewController
import com.downdogapp.client.singleton.App
import com.downdogapp.client.singleton.HistoryUtil
import com.downdogapp.client.views.start.HistoryPageView

object HistoryPage : Page {

  override val view = HistoryPageView()

  var displayFavorites = false
    set(value) {
      if (field != value) {
        logEvent("update_display_favorites", mapOf("favorites" to value.toString()))
        field = value
        view.refreshView()
      }
    }

  val displayItems
    get() =
      if (displayFavorites)
        HistoryUtil.favorites
      else
        HistoryUtil.items

  val noHistoryText
    get() = when {
      displayItems.isNotEmpty() -> null
      HistoryUtil.items.isEmpty() -> Strings.NO_HISTORY_TEXT
      else -> Strings.NO_SAVED_PRACTICES_TEXT
    }

  override fun refreshPage() {
    view.refreshView()
  }

  fun onItemClicked(item: HistoryItem) {
    App.pushViewController(HistoryItemViewController(item))
  }

  override val title: String
    get() = MANIFEST.historyPageTitle

  override val shouldDisplay: Boolean
    get() = MANIFEST.displayHistoryPage
}
